// utils/groupByDateAndInvoice.ts
import { InvoiceItem } from "../types/listTypes";

export function mappingListInvoice(data: InvoiceItem[]){
    const dateMap = new Map<string, Map<number, InvoiceItem[]>>();

    data.forEach((item) => {
        // Hitung cogm_amount setiap kali memproses item
        const updatedItem = {
          ...item,
          cogm_amount: Number(item.quantity_invoice) * Number(item.cogm),
          sale_profit: Number(item.total) - Number(item.total_tax_collect) - (Number(item.quantity_invoice) * Number(item.cogm))
        };
    
        // Jika tanggal transaksi belum ada di map, buatkan entri barunya
        if (!dateMap.has(updatedItem.transaction_date)) {
          dateMap.set(updatedItem.transaction_date, new Map());
        }
    
        // Ambil Map invoice di bawah tanggal transaksi tersebut
        const invoiceMap = dateMap.get(updatedItem.transaction_date)!;
    
        // Jika invoice_id belum ada, buatkan array kosong
        if (!invoiceMap.has(updatedItem.invoice_id)) {
          invoiceMap.set(updatedItem.invoice_id, []);
        }
    
        // Masukkan item ke array
        invoiceMap.get(updatedItem.invoice_id)!.push(updatedItem);
    });
  
    const grouped = Array.from(dateMap.entries()).map(([date, invoiceMap]) => {
        const invoices = Array.from(invoiceMap.entries()).map(([invoice_id, items]) => ({
          invoice_id,
          trx_code: items[0].trx_code,
          transaction_date: items[0].transaction_date,
          location_name: items[0].location_name,
          project_name: items[0].project_name,
          items,
        }));
    
        // Hitung total quantity_invoice di semua invoice dalam tanggal ini
        const total_quantity = invoices.reduce((acc, inv) => {
          const qtySum = inv.items.reduce((sum, item) => sum + Number(item.quantity_invoice || 0),0);
          return acc + qtySum;
        }, 0);

        const total_amount = invoices.reduce((acc, inv) => {
          const amountSum = inv.items.reduce((sum, item) => sum + Number(item.total || 0),0);
          return acc + amountSum;
        }, 0);

        const total_cogm_amount = invoices.reduce((acc, inv) => {
          const cogmAmountSum = inv.items.reduce((sum, item) => sum + Number(item.cogm_amount || 0),0);
          return acc + cogmAmountSum;
        }, 0);

        const total_sale_profit = invoices.reduce((acc, inv) => {
          const total = inv.items.reduce((sum, item) => sum + Number(item.sale_profit || 0),0);
          return acc + total;
        }, 0);
    
        return {
          transaction_date: date,
          invoices,
          total_quantity: Number(total_quantity), 
          total_amount : Number(total_amount),
          total_cogm_amount:Number(total_cogm_amount),
          total_sale_profit : Number(total_sale_profit)
        };
      });
  
    return grouped;
}